import CompaniesView from './CompaniesView.yaml?component';

export { CompaniesView };
